<template lang="pug">
  section
    .field.is-grouped
      .control
        button(class="button is-small" @click="openDeliveredPage()") 出荷管理IDリスト
      .control(v-for="deliver_type in listing_deliver_types" :key="deliver_type")
        button(@click="setDeliverType(deliver_type)" class="button is-small" :disabled="linkDisabled(deliver_type)") {{ deliver_type }}
    .field
      .control.is-pulled-right
        button(@click="submit()" class="button is-primary" :disabled="disabledSubmitButton()")
          | 出荷管理IDを作成&pdfをダウンロード
    div
      button(class="all-checkbox-button" @click="toggleAllCheckboxes") 全選択
      b-table(
          :data="data"
          :loading="loading"
          )
        template(slot-scope="props")
          b-table-column(field="checkbox" label="処理" width="100")
            b-checkbox(v-model="props.row.checkbox" true-value="true" false-value="false")
          b-table-column(field="book_shop_name" label="配本管理ID")
            | {{ props.row.sid }}
          b-table-column(field="agency_code" label="書籍名")
            | {{ bookName(props.row.isbn) }}
          b-table-column(field="total_order_items_size" label="配本件数")
            | {{ props.row.manipulated_order_items_size }}
          b-table-column(field="total_order_number" label="配本冊数")
            | {{ props.row.total_order_number }}
          b-table-column(field="deliver_type_id" label="リスト作成者")
            | {{ userName(props.row.user_id) }}
    b-field
      button(@click="submit()" class="button is-primary" :disabled="disabledSubmitButton()" id="submit-button")
        | 出荷管理IDを作成&pdfをダウンロード
</template>

<script>
import CacheDispatcher from 'mixins/cache_dispatcher'

export default {
  name: "new-delivered-order",
  mixins: [CacheDispatcher],
  data() {
    return {
      data: [],
      manipulated_orders: [],
      total: 0,
      loading: false,
      sortField: 'vote_count',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 25,
      isComponentModalActive: false,
      formProps: {
        shop_code_cont: '',
        name_cont: '',
        group_code_cont: '',
        telephone_cont: '',
        prefecture_cont: '',
        s: ''
      },
      default_params: null,
      allCheckboxSelected: 'false',
      listing_deliver_types: [
        "大村在庫", "日販在庫", "トーハン在庫", "京北在庫", "文響社在庫", "印刷所在庫", "直送(大村)", "直送(文響社)", "直送(京北)"
      ]
    }
  },
  props: {
    deliver_type_id: {
        type: Number,
        required: true
    },
  },
  // components: { 'search-modal-form': SearchModalForm },
  computed: {
    agencies(){ return this.$store.getters['Agencies/records'] },
    books(){  return this.$store.getters['Books/records'] },
    deliver_types(){  return this.$store.getters['DeliverTypes/records'] },
    accepting_order_routes(){  return this.$store.getters['AcceptingOrderRoutes/records'] },
    users(){ return this.$store.getters['Users/records'] },

  },
  methods: {
    openDeliveredPage(){
      window.location.href = `/users/delivered_orders`
    },
    /*
     * Load async data
     */
    onClick(row){
    },
    async submit(){
      var method = 'post'
      var url = `/api/v1/delivered_orders.json`
      var manipulated_order_ids = this.data.filter(item => item.checkbox == "true").map((item) =>{
        return item.id
      })
      var params = {
        delivered_order: {
          manipulated_order_ids: manipulated_order_ids
        }
      }
      this.loading = true
      this.error_message = null
      try{
        const res = await this.$http({ method: method, url: url, data: params })
        const data = res.data
        this.loading = false
        window.location.href = `/users/delivered_orders`
      }catch (error) {
        const {
          status,
          statusText,
          data
        } = error.response;
        this.loading = false
        this.error_message = data.messages.map((msg) => { return msg.message }).join(",")
        throw error
      }
    },
    disabledSubmitButton(){
      var result = true
      this.data.forEach((item) => {
        if(item.checkbox == 'true') {
          result = false
        }
      })
      return result
    },
    setDeliverType(deliver_type_name){
      const id = this.deliverTypeId(deliver_type_name)
      if(id)
        window.location.href = `/users/delivered_orders/new?deliver_type_id=${id}`
    },
    agencyName(agency_code){
      if (!agency_code) return ''
      let tmp = this.agencies
          .filter(agency => agency.code == agency_code)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    bookName(value){
      let a = this.getBook(value)
      return a != null ? `${a.name}: ${a.isbn}` : ''
    },
    bookAuthor(value){
      let a = this.getBook(value)
      return a != null ? `${a.author}` : ''
    },
    bookReleasedOn(value){
      let a = this.getBook(value)
      return a != null ? `${a.released_on}` : ''
    },
    bookSellingPrice(value){
      let a = this.getBook(value)
      return a != null ? `${a.selling_price}` : ''
    },
    getBook(value){
      if (!value) return null
      let a = this.books.filter(book => book.isbn == value || book.id == value)
      return a.length > 0 ? a[0] : null
    },
    orderRouteName(id){
      if (!id) return ''
      let tmp = this.accepting_order_routes
          .filter(route => route.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeName(id){
      if (!id) return ''
      let tmp = this.deliver_types
          .filter(type => type.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeId(deliver_type_name) {
      if(!deliver_type_name) return ''
      let tmp = this.deliver_types.filter(type => type.name == deliver_type_name)
      if(tmp.length == 0)
       return ''
      return tmp[0].id
    },
    linkDisabled(deliver_type_name) {
      const id = this.deliverTypeId(deliver_type_name)
      if(!id) return true

      const manipulated_orders = this.manipulated_orders.filter(order => order.deliver_type_id == id)
      if(manipulated_orders.length > 0)
        return false

      return true
    },
    userName(id){
      if (!id) return ''
      let tmp = this.users
          .filter(user => user.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    loadAsyncData() {
      this.loading = true
      const per_page = 999999
      this.$http.get(`/api/v1/manipulated_orders?q[delivered_order_id_null]=1&per_page=${per_page}`)
          .then(({data}) => {
            this.data = []
            data.manipulated_orders.forEach((item) => {
              if(item.total_order_number <= 0) return

              if(item.deliver_type_id == this.deliver_type_id) {
                item['checkbox'] = false
                this.data.push(Object.assign({}, item))
              }
              this.manipulated_orders.push(Object.assign({}, item))
            })
            this.loading = false
          })
          .catch((error) => {
            this.data = []
            this.total = 0
            this.loading = false
            throw error
          })
    },
    toggleAllCheckboxes() {
      this.allCheckboxSelected = this.allCheckboxSelected == "true" ? 'false' : 'true'
      this.data.forEach(d => {
        d.checkbox = this.allCheckboxSelected
      })
    }
  },
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate(value, length) {
      return value.length > length
          ? value.substr(0, length) + '...'
          : value
    }
  },
  created(){
    this.default_params = '?' + [
      `page=${this.page}`,
      Object.keys(this.formProps).map((key) => {
        return `q[${key}]=${this.formProps[key]}`
      }).join('&')
    ].join('&')

    this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
    this.$store.dispatch('Books/fetch', 'books')
    this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
    this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
    this.$store.dispatch('Users/fetch', 'users')
  },
  mounted() {
    this.loadAsyncData()
  }
}

</script>
